export var assign_marker_varying = "\n#if defined(dRenderVariant_color) || defined(dRenderVariant_marking)\n    vMarker = readFromTexture(tMarker, aInstance * float(uGroupCount) + group, uMarkerTexDim).a;\n#endif\n";
